import { RateTariff } from "../models/rateTariff/RateTariff";

import ServiceBase from "../services/ServiceBase";

class RateTariffsService extends ServiceBase {
  getAll(): Promise<RateTariff[]> {
    return this.get<RateTariff[]>("/api/rate-tariffs");
  }
}

export default new RateTariffsService();